import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import useReveal from "../hooks/useReveal";

export default function VoucherStores({ content = {} }) {
  const [idx, setIdx] = useState(0);
  const { ref, cls } = useReveal();
  const slides = (content.store_slides || []).filter(Boolean);
  const total = slides.length || 1;

  const prev = () => setIdx((i) => (i - 1 + total) % total);
  const next = () => setIdx((i) => (i + 1) % total);

  return (
    <section className="bg-white py-24">
      <div ref={ref} className={`max-w-[1000px] mx-auto px-6 text-center ${cls}`}>
        <h2 className="gp-heading text-[2.4rem] sm:text-[3rem]">
          {content.stores_title || "The beautiful way to sell your gift vouchers"}
        </h2>
        <p className="text-[#5a6b80] text-[1.15rem] mt-5 max-w-[560px] mx-auto">
          {content.stores_subtitle || "Launching your own branded gift voucher store has never been faster or simpler."}
        </p>

        <div className="relative mt-14">
          <button
            onClick={prev}
            aria-label="Previous"
            className="absolute -left-4 sm:-left-8 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-white border border-gray-200 flex items-center justify-center shadow-md hover:bg-[#16243b] hover:text-white hover:border-[#16243b] transition-colors"
          >
            <ChevronLeft size={22} />
          </button>

          <div className="overflow-hidden rounded-2xl shadow-[0_25px_70px_rgba(20,30,55,0.18)]">
            <div
              className="flex transition-transform duration-500 ease-out"
              style={{ transform: `translateX(-${idx * 100}%)` }}
            >
              {slides.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt={`Voucher listing page ${i + 1}`}
                  className="w-full flex-shrink-0 object-cover"
                />
              ))}
            </div>
          </div>

          <button
            onClick={next}
            aria-label="Next"
            className="absolute -right-4 sm:-right-8 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-white border border-gray-200 flex items-center justify-center shadow-md hover:bg-[#16243b] hover:text-white hover:border-[#16243b] transition-colors"
          >
            <ChevronRight size={22} />
          </button>
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              aria-label={`Slide ${i + 1}`}
              className={`h-2 rounded-full transition-all ${
                i === idx ? "w-8 bg-[#2ec9c9]" : "w-2 bg-gray-300"
              }`}
            />
          ))}
        </div>

        <a href="#features" className="gp-btn-outline inline-block rounded-full px-8 py-3 font-medium mt-12">
          {content.stores_cta || "Learn about voucher stores"}
        </a>
      </div>
    </section>
  );
}
